import '@hotwired/turbo-rails';
import '../../controllers/university_portal';
import loadTrackpoint from '../../modules/trackpoint/load';

loadTrackpoint();
